import Sprite from "../object-graphics/Sprite";
import { TILES } from "../../helpers/tiles";
import { INVENTORY } from "../../helpers/consts";
import styles from "./HUDInventory.module.css";

const showInventory = [
  {
    key: INVENTORY.FIRE_PICKUP,
    tile: TILES.FIRE_PICKUP,
  },
  {
    key: INVENTORY.ICE_PICKUP,
    tile: TILES.ICE_PICKUP,
  },
  {
    key: INVENTORY.WATER_PICKUP,
    tile: TILES.WATER_PICKUP,
  },
  {
    key: INVENTORY.BLUE_KEY_PICKUP,
    tile: TILES.BLUE_KEY,
  },
  {
    key: INVENTORY.GREEN_KEY_PICKUP,
    tile: TILES.GREEN_KEY,
  },
  {
    key: INVENTORY.BULLET_PICKUP,
    tile: TILES.BULLET,
  },
  {
    key: INVENTORY.CLOWN_DEFENSE,
    tile: TILES.CLOWN_DEFENSE_PICKUP,
  },
];

export default function HUDInventory({ level }) {
  return (
    <div className={styles.inventory}>
      {showInventory
        .filter((i) => {
          return level.inventory.has(i.key);
        })
        .map((i) => {
          return (
            <div key={i.key} className={styles.inventoryEntry}>
              <Sprite frameCoord={i.tile} />
            </div>
          );
        })}
    </div>
  );
}
